"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectStores = void 0;
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../stores/RootStore");
const injectStores = (WrappedComponent) => {
    const ExtendedComponent = class extends WrappedComponent {
        UNSAFE_componentWillMount() {
            Object.getOwnPropertyNames(this.props.rootStore).forEach((propertyName) => {
                if (this[propertyName] === undefined) {
                    Object.defineProperty(this, propertyName, {
                        ...Object.getOwnPropertyDescriptor(this, propertyName),
                        value: this.props.rootStore[propertyName]
                    });
                }
            });
        }
    };
    return (props) => {
        const rootStore = react_1.default.useContext(RootStore_1.RootStoreContext);
        return (react_1.default.createElement(ExtendedComponent, { ...props, rootStore: rootStore }, props.children));
    };
};
exports.injectStores = injectStores;
